import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((muiTheme: Theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: muiTheme.spacing(3),
    },
    row: {
        marginBottom: muiTheme.spacing(1),
    },
    paragraph: {
        marginBottom: muiTheme.spacing(2),
    },
    subscriptionButton: {
        alignSelf: "flex-end",
    },
    ownersHeader: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: muiTheme.spacing(2),
    },
    ownersActions: {
        display: "flex",
        gap: muiTheme.spacing(1),
    },
    bold: {
        fontWeight: "bold",
    },
}));
